var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.95,
    height: 92.95,
    viewBox: "0 0 92.95 92.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #cee5dd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "infos_icons",
    "data-name": "infos icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desktopIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 92.95,
    height: 92.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.28,11.55H3.68A2.43,2.43,0,0,0,1.25,14V74.45a2.43,2.43,0,0,0,2.43,2.43H38.94l-2.12,8.46H23a1.59,1.59,0,0,0-1.59,1.59v3.44A1.59,1.59,0,0,0,23,92H70a1.59,1.59,0,0,0,1.59-1.58V86.93A1.59,1.59,0,0,0,70,85.34H56.13L54,76.88H89.28a2.43,2.43,0,0,0,2.42-2.43V14A2.43,2.43,0,0,0,89.28,11.55Zm-3.59,56.9H7.27v-51H85.69Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopIcon);
export default __webpack_public_path__ + "static/media/desktopIcon.559dd032f1281b87081e084164cbcb4f.svg";
export { ForwardRef as ReactComponent };